import { render, staticRenderFns } from "./bind-box-dialog.vue?vue&type=template&id=61f477c6&scoped=true&"
import script from "./bind-box-dialog.vue?vue&type=script&lang=js&"
export * from "./bind-box-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61f477c6",
  null
  
)

export default component.exports